import React from "react"
import "./GoalAchievabilityIcon.css"

const GoalAchievabilityIcon = ({ name, icon: Icon, grade, size }) => (
  <div className={`GoalAchievability GoalAchievability__Graded--${grade}`}>
    <div style={{ fontSize: size }} className="GoalAchievability__GradedIcon">
      <Icon
        className={`GoalAchievability__Image GoalAchievability__Image--${name}`}
      />
    </div>
  </div>
)

GoalAchievabilityIcon.defaultProps = {
  size: "3.2em"
}

export default GoalAchievabilityIcon
